import React from 'react';
import { GitCompare } from 'lucide-react';
import { ipaToPhones } from '../../lib/samuel/phonetic';

// "?cmp=fɔə|fɔɹ&cmpl=New York|General American&text=four": the tract articulates both transcriptions, one after the other.
export const CompareBox = ({ lab }) => {
  const q = new URLSearchParams(window.location.search);
  const [a, b] = (q.get('cmp') || '').split('|');
  if (!a || !b) return null;
  const [la, lb] = (q.get('cmpl') || 'A|B').split('|');
  const word = q.get('text') || '';
  const pa = ipaToPhones(a), pb = ipaToPhones(b);
  const play = () => lab.fromPhones([...pa, ...pb], `${word} · ${la} → ${lb}`, { rate: 0.55, gaps: [pa.length - 1], gapMs: 650 });
  return (
    <div className="space-y-2 rounded-xl border border-amber-400/40 bg-amber-400/[0.06] p-3" data-testid="lab-compare-box">
      <p className="text-[10px] uppercase tracking-[0.2em] text-amber-300 font-bold">Confronto · {word}</p>
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <span className="px-2 py-1 rounded-lg bg-slate-950 border border-white/10"><span className="text-[10px] text-slate-400 mr-1.5">{la}</span><b data-testid="lab-compare-a">[{a}]</b></span>
        <span className="text-amber-300">→</span>
        <span className="px-2 py-1 rounded-lg bg-slate-950 border border-white/10"><span className="text-[10px] text-slate-400 mr-1.5">{lb}</span><b data-testid="lab-compare-b">[{b}]</b></span>
      </div>
      <button onClick={play} disabled={!!lab.status || !lab.eng.ready()} className="w-full flex items-center justify-center gap-2 py-2 rounded-xl bg-amber-400 hover:bg-amber-300 text-slate-950 text-sm font-bold disabled:opacity-40" data-testid="lab-compare-play">
        <GitCompare className="w-4 h-4" /> Articola le due versioni
      </button>
      <p className="text-[11px] text-slate-400">Il tratto vocale pronuncia prima [{a}], poi [{b}], dalla trascrizione IPA (suono sintetico).</p>
    </div>
  );
};
